export default {
  postCheck: (state) => {
    return state.postCheck;
  },

  loginCheck: (state) => {
    return state.loginCheck;
  },

  forgotCheck: (state) => {
    return state.forgotCheck;
  },
  forgotBtn: (state) => {
    return state.forgotBtn;
  },

  userProfile: state => {
    return state.userProfile;
  },

  captcha: (state) => {
    return state.captcha;
  },
  loadingBtn: (state) => {
    return state.loadingBtn;
  },

};
